import { defineComponent as _defineComponent } from 'vue'
import { ContentLoader } from '@tencent/wphk-components-content-loader';
import CardContainer from '@/components/card-container.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'card-content-loader',
  setup(__props) {


return { __sfc: true,ContentLoader, CardContainer }
}

})